// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var GitBranch = function GitBranch(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.815 2.356A2.25 2.25 0 1011 5.371V6a1 1 0 01-1 1H6a2.472 2.472 0 00-1 .208V5.371a2.25 2.25 0 10-1.5 0v5.256a2.25 2.25 0 101.5 0V9.5a1 1 0 011-1h4A2.5 2.5 0 0012.5 6v-.629a2.25 2.25 0 001.314-3.015zM4.781 13.279a.748.748 0 11.22-.53.75.75 0 01-.22.53zm0-9.5A.748.748 0 115 3.249a.75.75 0 01-.219.53zm7.5 0a.748.748 0 11.22-.53.75.75 0 01-.22.53z"
    }))
  );
};

export default GitBranch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/GitBranch.js
// module id = 1016
// module chunks = 0